import { AccessibilityInfo, Platform, type ViewInstance } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Moves keyboard focus on web and screen reader focus on native, since a
 * native `focus()` call only reaches text inputs.
 */
export function focusNavbarMenuElement(element: ViewInstance | null | undefined) {
  if (!element) {
    return;
  }

  if (Platform.OS === 'web') {
    element.focus();

    return;
  }

  AccessibilityInfo.sendAccessibilityEvent(element, 'focus');
}
